import { render } from "./CheckPointBathroom.vue?vue&type=template&id=f89b1dee"
import script from "./CheckPointBathroom.vue?vue&type=script&lang=js"
export * from "./CheckPointBathroom.vue?vue&type=script&lang=js"

import exportComponent from "D:\\All\\Job freelance\\CRA-brainy\\Develop\\cra-brainy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__